<template>
	<div id="contact-component" >
		<LandingHeaderBar class="white-header "/>	
		<LandingContact class="contact"/>
	</div>
</template>

<script>

import LandingHeaderBar from '../shared-views/landing-header-bar/Landing-Header-Bar.vue'
import LandingContact from './landing-contact/Landing-Contact.vue'

export default {
	name: 'LandingContactComponent',

	components: {
		LandingHeaderBar,
		LandingContact,
	}
}

</script>

<style scoped>
	.white-header {
		height: 5em;
	}
</style>